import { computed, reactive } from "vue";
import { Observable } from "rxjs";

import Account from "@/helper/AccountHelper.js";
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import DeliveryHelper from "@/helper/DeliveryHelper.js";
// service
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
import { AuthDeviceLoginConfigBuilder } from '@/core/Account/config/AuthConfigModel';
import BKDeliveryMethod from "@/module/DeliveryMethod/service/BKDeliveryMethod.js";
import BKSubscription from '@/module/Subscription/List/service/BKSubscription'

const obserInit = new Observable((subscriber) => {
    if (state.isInitial) {
        subscriber.next(state.isLogin);
    } else {
        subInitList.push(subscriber);
    }
});
const subInitList = [];

const state = reactive({
    isInitial: false,
    isLogin: false,
    profile: null,
    point: 0,
    isCheckLoginGoogle: false,
});

const methods = {
    init: function () {
        if (Account.isLogin()) {
            // console.log('is login');
            this.setupAfterLogin();
        } else {
            this.loginDevice();
            // console.log('is not login');
            // state.isLogin = false;
            // state.isInitial = true;
        }
    },
    loginDevice: function () {
        let config = new AuthDeviceLoginConfigBuilder()
            .genUUID()
            .create()
            .getParams()

        BzbsAuth.apiLoginDevice(config).subscribe({
            next: (data) => {
                Account.setLogin(data);
                this.setupAfterLogin();
            },
            error: (err) => {
                console.log(err);
            },
        })
    },
    setupAfterLogin: async function () {
        if (await this.setupProfile()) {
            if (await this.setupDelivery()) {
                state.isLogin = true;
                state.isInitial = true;
                sendEventInit();
            }
            await this.checkSubscription();
        }
    },
    setupProfile: function () {
        return new Promise((resolve) => {
            BzbsProfile.getProfile().subscribe({
                next: (data) => {
                    // console.log('profile', data);
                    state.profile = data.profile;
                    state.point = data.profile.updated_points.points;
                    resolve(true);
                },
                error: (err) => {
                    state.isLogin = false;
                    state.isInitial = true;
                    console.log(err);

                    if (err.id == 412 || err.id == 1905) {
                        Account.removeCacheUser();
                        window.location.reload();
                    }
                    resolve(false);
                },
            });
        });
    },
    checkSubscription: function () {
        return new Promise((resolve) => {
            BKSubscription.apiGetMyPackages().subscribe({
                next: (res) => {
                    if (res.data.length > 0) {
                        state.profile.isSubsciption = true;
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                },
                error: (err) => {
                    console.log(err);
                    resolve(false);
                },
            });
        });
    },
    setupDelivery: function () {
        return new Promise((resolve) => {
            BKDeliveryMethod.apiGetCartDelivery().subscribe({
                next: (data) => {
                    DeliveryHelper.setCacheDelivery(data);
                    resolve(true);
                },
                error: (err) => {
                    console.log(err);
                    resolve(false);
                },
            });
        });
    },
    loginStatus: function () {
        return obserInit;
    },
    setProfile: function (profile) {
        state.profile = profile;
    },
    setUpdatePoint: function (point) {
        state.point = point;
    },
    setCheckLoginGoogle: function () {
        state.isCheckLoginGoogle = true;
    }
};

const getters = {
    isLoginGuest: computed(() => {
        if (state.isInitial) {
            let account = Account.getCacheUser();
            // return account?.loginChanel == 'device';
            if (account.loginChanel) 
                return account?.loginChanel == 'device';
            else  
                return account?.channel == 'device';
        }

        return true
    }),
    isLoginAccount: computed(()=>{
        return !getters.isLoginAccount.value
    })
}

function sendEventInit() {
    for (let i of subInitList) {
        i.next(state.isLogin);
    }
}

export default {
    state: state,
    methods: methods,
    getters,
};
